import { EventName } from "core";
import { useOptionalAuthContext } from "../auth/useAuthContext";
import { useTrackEvent } from "./useTrackEvent";

export function useSignOut() {
  const { signOut } = useOptionalAuthContext();
  const { track } = useTrackEvent();

  function onSignOut() {
    track(EventName.LoggedOut);
    signOut();
  }

  return {
    signOut: onSignOut,
  };
}
